import _ from "lodash"
import * as Types from "../../index"
import TypeDynamicNestedMF from "./TypeDynamicNestedMF"
import CustomButton from "../../../Buttons/CustomButton"
import styles from "../../../../styles/Form-NestedMB.module.css"

export default function NestedMFBuilder(props) {
  const {
    arrayHelpers,
    fields,
    mfDefinition,
    mfFieldName,
    mfIndex,
    nestedMfFieldName,
    nestedMfIndex,
    mfLength,
  } = props

  const handleMFTypes = () => {
    return _.map(fields, (field) => {
      const newProps = {
        type: "nested-multi-field",
        field,
        mfFieldName,
        nestedMfFieldName,
        mfIndex,
        nestedMfIndex,
      }

      switch (field.field_type) {
        case "dynamic":
          return <TypeDynamicNestedMF {...newProps} key={field.field_name} />
        case "text":
          return <Types.TypeText {...newProps} key={field.field_name} />
        case "textarea":
          return <Types.TypeTextarea {...newProps} key={field.field_name} />
        case "radio":
          return <Types.TypeRadio {...newProps} key={field.field_name} />
        case "dropdown":
          return <Types.TypeDropdown {...newProps} key={field.field_name} />
        case "date":
          return <Types.TypeDate {...newProps} key={field.field_name} />
        case "phone":
          return <Types.TypeTel {...newProps} key={field.field_name} />
        default:
          return null
      }
    })
  }

  return (
    <>
      <div className={styles.blockNested}>
        {handleMFTypes()}
        {mfLength > 1 && (
          <CustomButton
            label="Remove Item"
            icon="pi pi-trash"
            severity="danger"
            onClick={() => arrayHelpers.remove(nestedMfIndex)}
            size="small"
            outlined
            className={styles.removeButton}
          />
        )}
      </div>

      {nestedMfIndex === mfLength - 1 && (
        <div className={styles.actions}>
          <CustomButton
            label="Add New Item"
            icon="pi pi-plus"
            onClick={() => arrayHelpers.insert(mfLength, mfDefinition)}
            size="small"
            outlined
            className={styles.addButton}
          />
        </div>
      )}
    </>
  )
}
